module.exports = __webpack_public_path__ + "img/pr-5.7301f11e.png";